var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-5 pt-5" },
    [
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Comprobante")
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Fecha de emisión")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(_vm.receipt.fechaCreacion)
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Estado")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.receiptsStates[_vm.receipt.estado].label) +
                        " "
                    )
                  ])
                ])
              ]),
              _vm.receipt.fechaMaximaPago
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Fecha máxima de pago")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(" " + _vm._s(_vm.receipt.fechaMaximaPago) + " ")
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.monto
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Monto del comprobante")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("amount")(_vm.receipt.monto)) +
                            " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.iva
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Iva")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " + _vm._s(_vm._f("amount")(_vm.receipt.iva)) + " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.impuestoEspecifico
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Impuesto específico")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("amount")(_vm.receipt.impuestoEspecifico)
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.garantiaMonto
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Monto Garantía")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("amount")(_vm.receipt.garantiaMonto)
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.montoPorPagar
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Monto Por Pagar")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("amount")(_vm.receipt.montoPorPagar)
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.receipt.montoTotal
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Monto Total del comprobante")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("amount")(_vm.receipt.montoTotal)) +
                            " "
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Adjudicatario")
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Rut")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.receipt.adjudicatarios.rut) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Razón Social")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.receipt.adjudicatarios.nombre) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Ciudad")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.receipt.adjudicatarios.ciudad) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Teléfono")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.receipt.adjudicatarios.telefono) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Correo")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.receipt.adjudicatarios.correo) + " "
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Subasta")
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Folio")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.receipt.subasta.folio) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Rut")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.receipt.subasta.gestora.iut) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-12 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Razón Social")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.receipt.subasta.gestora.razonSocial) +
                        " "
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [_vm._v("Lote")])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Folio")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.receipt.lote.folio) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Calidad Juridica")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.receipt.lote.calidadJuridicaNombre) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-12 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Descripción lote")]),
                  _c("div", { staticClass: "ml-3 container-description" }, [
                    _vm._v(" " + _vm._s(_vm.receipt.lote.descripcionLote) + " ")
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }